import React from 'react';
import './Spinner.css';

const Spinner = () => (
  <div className="hp-spinner">
    <div className="hp-spinner__ring" />
    <div className="hp-spinner__star">✦</div>
  </div>
);

export default Spinner;
